import { Ref } from "@tblabs/truffle";
import { UploadState } from '../../../Models/UploadState';
import { Icon } from "../../General/Icon";


export class UploadIcon extends Icon
{
    constructor(uploadState: Ref<UploadState>)
    {
        super("cloud_download", "white");
        this.Class("save-button");

        let allowClick = true;

        uploadState.OnChange(uploadState =>
        {
            switch (uploadState)
            {
                case UploadState.StartUploading:
                    this.BecomeText("Uploading...").Color("#fff").Cursor("wait");
                    // TODO: allowClick = false; ??????????????? co jeśli upload chwile trwa i użytkownik kliknie ponownie?
                    break;

                case UploadState.Uploaded:
                    this.BecomeText("Saved").Color("#fff").Cursor("default");
                    allowClick = false;
                    break;

                case UploadState.Error:
                    this.BecomeText("Error").Normal().Bold().Color("red").FontSize(16).CursorDefault()
                    setTimeout(() =>
                    {
                        this.BecomeIcon().Color("red").CursorPointer()
                    }, 3000);
                    break;
            }
        }, true);

        this.OnClick(async () =>
        {
            if (!allowClick) return;

            uploadState.value = UploadState.StartUploading;
        });
    }
}
